export function applyBottomSpacer() {
  const urlParams = new URLSearchParams(window.location.search);
  const bottomSpacer = urlParams.get('bottomSpacer');

  if (!bottomSpacer) {
    return;
  }

  document.documentElement.style.setProperty('--bottom-spacer-height', `${bottomSpacer}`);
}
